import { render } from "./CardFormula.vue?vue&type=template&id=4b9085be&scoped=true"
import script from "./CardFormula.vue?vue&type=script&lang=js"
export * from "./CardFormula.vue?vue&type=script&lang=js"

import "./CardFormula.vue?vue&type=style&index=0&id=4b9085be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b9085be"

export default script